// Individual imports for each component used in this sample
import "@arcgis/map-components/components/arcgis-zoom";
import "@arcgis/map-components/components/arcgis-legend";
import "@arcgis/map-components/components/arcgis-search";
import "@arcgis/map-components/components/arcgis-basemap-gallery";
import "@arcgis/map-components/components/arcgis-expand";
import "@arcgis/map-components/components/arcgis-scale-bar";
import "@arcgis/map-components/components/arcgis-compass";
import "@arcgis/map-components/components/arcgis-layer-list";
import "@arcgis/map-components/components/arcgis-fullscreen";
import "@arcgis/map-components/components/arcgis-home";

export default function DefaultWidgets() {
  return (
    <>
      <arcgis-zoom slot="top-left" />
      <arcgis-home slot="top-left" />
      {/* <arcgis-compass slot="top-left" /> */}
      <arcgis-fullscreen slot="top-left" />
      <arcgis-expand slot="top-left" expandTooltip="Layer List">
        <arcgis-layer-list />
      </arcgis-expand>
      <arcgis-search slot="top-right" />
      {/* <arcgis-expand expanded={false} slot="top-right" expandTooltip="Legend">
        <arcgis-legend />
      </arcgis-expand> */}
      <arcgis-scale-bar slot="bottom-left" />
      <arcgis-expand slot="top-right" expandTooltip="Basemap Gallery">
        <arcgis-basemap-gallery />
      </arcgis-expand>
    </>
  );
}
